import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import Email from 'components/forms/Email';
import Telphone from 'components/forms/TelPhone';
import Toast from 'components/Toast';
import VerifyCodeSend from 'components/VerifyCodeSend';
import APP from 'stores/APP';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

import './style.scss';

interface LocationState {
    verify_token: string;
}

const VerifyIdentity: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const $formutil = useForm<{
        phone?: string;
        tel_code?: string;
        email?: string;
    }>();
    const isEmail = location.pathname.indexOf('email') > -1;
    const { $params, $errors, $invalid, $getFirstError, $batchDirty } = $formutil.$new();
    const verifyToken = (location.state as LocationState)?.verify_token;

    const submit = async () => {
        isEmail
            ? APP.trackEvent('安全中心', '邮箱认证_去设置', '邮箱去设置_下一步')
            : APP.trackEvent('安全中心', '手机认证_去设置', '去设置_下一步');

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const params = {
                    ...$params,
                    verify_token: verifyToken
                };

                await http.post(API.OAUTH[isEmail ? 'bindEmail' : 'bindPhone'](), params);

                security.getStatus();

                navigate('../3');
            } catch (err) {
                // 操作时长过长
                if (err.error_code === 11804) {
                    navigate('../1');
                }

                Toast.show(err);
            }

            setLoading(false);
        }
    };

    if (!verifyToken) {
        return <Navigate to="../1" replace />;
    }

    return (
        <Form onFinish={submit} layout="vertical">
            {isEmail ? (
                <>
                    <Email placeholder={__('请输入邮箱')} name="email" />
                    <VerifyCodeSend type="email" username={$errors.email ? '' : $params.email} process="bind_email" />
                </>
            ) : (
                <>
                    <Telphone />
                    <VerifyCodeSend
                        tel_code={$params.tel_code}
                        type="phone"
                        username={$params.phone}
                        process="bind_phone"
                    />
                </>
            )}
            <CardButtonWrap>
                <Button
                    block
                    type="primary"
                    size="large"
                    className="verify-identify-btn"
                    loading={loading}
                    htmlType="submit">
                    {__('下一步')}
                </Button>
            </CardButtonWrap>
            <Debug data={$formutil.$params} />
        </Form>
    );
};

export default withForm(VerifyIdentity);
